import Vue from 'vue'

const vueObj = new Vue()

const state = {}

const actions = {
  SAVE_FACEBOOK_COINS: ({commit}, submitData) => {
    const url = 'social-campaigns/facebook-coins'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          vueObj.$swal({text: 'Success', type: 'success'})
        } else {
          vueObj.$swal({text: response.message, type: 'error'})
        }
      })
  }
}

const mutations = {}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/social.campaign.js